import { SET_MICRO_SERVICE } from "state/actions/microService";
import createReducer from "./createReducer";

export default createReducer<string>({ successType: SET_MICRO_SERVICE });
